const generalDE = {
    "modalConfirm": {
        "button": {
            "cancel": "Abbrechen",
            "confirm": "Bestätigen"
        }
    },
    "tableDropdown": {
        "action": "Aktion",
        "edit": "Bearbeiten",
        "delete": "Löschen",
        "viewDetails": "Details anzeigen",
        "copyMLId": "ML-ID kopieren",
        "viewStats": "Statistiken anzeigen"
    },
    "tableModal": {
        "cancel": "Abbrechen",
        "confirm": "Bestätigen",
        "edit": "Bearbeiten"
    },
    "invoiceModal": {
        "button": {
            "cancel": "Abbrechen",
            "confirm": "Bestätigen"
        }
    },
    "select": {
        "placeholder": "Auswählen..."
    },
    "asyncDropdown": {
        "placeholder": "Suchen...",
        "loading": "Laden...",
        "noResults": "Keine Optionen",
        "blacklisted": "Auf der schwarzen Liste"
    },
    "table": {
        "noDataAvailable": "Keine Daten verfügbar"
    },
    "tableHelper": {
        "loading": "Laden...",
        "error": "Fehler aufgetreten",
        "noData": "Es sind keine Daten verfügbar"
    },
    "countriesSelect": {
        "placeholder": "Land suchen..."
    },
    "consentModal": {
        "header": "Zustimmung erforderlich",
        "body": {
            "description": "Bitte überprüfen und akzeptieren Sie unsere neuen Zustimmungskonditionen, um unsere Dienste weiterhin nutzen zu können.",
            "label": {
                "firstName": "Vorname",
                "lastName": "Nachname",
                "email": "E-Mail",
                "termsOfUsageAgreement": "Ich stimme den <1>Nutzungsbedingungen</1> zu",
                "privacyPolicyAgreement": "Ich stimme der <1>Datenschutzerklärung</1> zu",
                "cookiePolicyAgreement": "Ich stimme der <1>Cookie-Richtlinie</1> zu"
            }
        },
        "button": {
            "submit": "Einreichen"
        }
    },
    "passwordResetModal": {
        "header": "Ändern Sie Ihr Passwort",
        "body": {
            "form": {
                "label": {
                    "currentPassword": "Aktuelles Passwort",
                    "newPassword": "Neues Passwort",
                    "repeatNewPassword": "Neues Passwort wiederholen"
                },
                "button": {
                    "submit": "Einreichen"
                },
                "message": {
                    "currentPasswordRequired": "Ihr altes Passwort ist erforderlich",
                    "newPasswordRequired": "Neues Passwort ist erforderlich",
                    "newPasswordMinLength": "Ihr Passwort sollte mindestens 10 Zeichen lang sein",
                    "newPasswordDifferentFromOld": "Das neue Passwort muss sich vom alten Passwort unterscheiden",
                    "newPasswordConfirmation": "Das neue Passwort muss übereinstimmen"
                }
            }
        },
        "footer": {
            "note": "<strong>Hinweis: </strong>Es ist eine Weile her, seit Sie Ihr Passwort zuletzt aktualisiert haben. Zu Ihrer Sicherheit setzen Sie bitte Ihr Passwort zurück."
        },
        "message": {
            "success": "Ihr Passwort wurde geändert!",
            "error": "Etwas ist schief gelaufen! Bitte Seite aktualisieren und erneut versuchen!"
        },
        "modal": {
            "confirm": {
                "header": "Sind Sie sicher, dass Sie Ihr Passwort ändern möchten?",
                "body": "Bitte bestätigen"
            }
        }
    },
    "qcFeedback": {
        "label": {
            "qcFeedback": "QC Feedback"
        }
    },
    "subUserFilter": {
        "label": {
            "subUser": "Unterbenutzer: "
        },
        "placeholder": {
            "subUser": "Unterbenutzer auswählen"
        },
        "button": {
            "reset": "Zurücksetzen"
        }
    },
    "footer": {
        "label": {
            "copyright": "Urheberrecht © {{year}}",
            "allRightsReserved": "Alle Rechte vorbehalten.",
            "privacyPolicy": "Datenschutzerklärung",
            "termsAndConditions": "Geschäftsbedingungen"
        }
    },
    "promoBannerHeader": {
        "exclusiveOfferFor": "Exklusive Angebote für",
        "off": "OFF",
        "promoCode": "Promo-Code",
        "expiresIn": "Gültig bis",
        "clickHereToAvailThisOffer": "Hier klicken, um dieses Angebot zu nutzen",
        "availableOnAllSubscriptionPlans": "Verfügbar auf allen Abonnementplänen."
    },
    "promoBanner": {
        "exclusiveOfferFor": "Exklusive Angebote für",
        "off": "OFF",
        "limitedTimePromoOffer": "Dieser Zeitbegrenzte Promo-Code wurde ausschließlich für Sie erstellt. Missen Sie diese Gelegenheit nicht!",
        "promoCode": "Ihr Promo-Code",
        "expiresIn": "Gültig bis",
        "days": "Days",
        "hours": "Stunden",
        "minutes": "Minuten",
        "seconds": "Sekunden",
        "availableOnAllSubscriptionPlans": "Dieses exklusive Angebot ist auf allen Abonnementplänen verfügbar."
    }
};

export default generalDE;